import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors, breakpoints } from '@/styles'
import { Label } from '@/components/text'
import HeaderCheck from './header-check.svg'
import HeaderDot from './header-dot.svg'
import EmptyCircle from './empty-circle.svg'

const ProgressWrapper = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  flex: 1;
  min-width: 120px;
  padding: 0 20px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    display: none;
  }
`

const IconContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const IconWrapper = styled.div`
  position: relative;
`

const ProgressLabel = styled(Label)`
  position: absolute;
  margin: 0;
  top: 20px;
  left: -50px;
  width: 120px;
  color: ${props => (props.selected ? colors.black : colors.grey56)};
  line-height: 16px;
  text-align: center;
`

const ProgressBefore = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${colors.grey88};
  margin-top: -14px;
`

const ProgressAfter = styled.div`
  width: ${props => {
    switch (props.currentStep) {
      case 'leaseTerms':
        return `25%`
      case 'recipients':
        return `50%`
      case 'setLocation':
        return `75%`
      case 'createContract':
        return `100%`
      default:
        return `0%`
    }
  }};
  height: 2px;
  background-color: ${colors.link};
  margin-top: -2px;
`

const DropShadowImg = styled.img`
  box-shadow: 0px 1px 3px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 6%);
  border-radius: 8px;
`

const ProgressBar = ({ currentStep, isEdit = false }) => {
  const { t } = useTranslation()
  const createMenus = ['documents', 'leaseTerms', 'recipients', 'buildDocuments', 'createContract']
  const createLabels = {
    documents: t('l.contract_edit.progress_bar.documents.button', 'Documents'),
    leaseTerms: t('l.contract_edit.progress_bar.lease_terms.button', 'Lease Terms'),
    recipients: t('l.contract_edit.progress_bar.recipients.button', 'Recipients'),
    buildDocuments: t('l.contract_edit.progress_bar.build_documents.button', 'Build Documents'),
    createContract: t('l.contract_edit.progress_bar.save_and_preview.button', 'Save & Preview')
  }

  const editMenus = ['buildDocuments', 'createContract']
  const editLabels = {
    buildDocuments: t('l.contract_edit.progress_bar.build_documents.button', 'Build Documents'),
    createContract: t('l.contract_edit.progress_bar.save_and_preview.button', 'Save & Preview')
  }
  const menus = isEdit ? editMenus : createMenus
  const labels = isEdit ? editLabels : createLabels
  return (
    <ProgressWrapper>
      <IconContainer>
        {menus.map((item, i) => {
          let imgSrc
          let selected = false
          if (menus.indexOf(item) <= menus.indexOf(currentStep)) {
            imgSrc = HeaderCheck
            selected = true
          } else {
            imgSrc = EmptyCircle
          }
          if (item === currentStep) {
            imgSrc = HeaderDot
            selected = true
          }
          return (
            <IconWrapper key={item}>
              <DropShadowImg src={imgSrc} alt="icon" />
              <ProgressLabel fontSize="14px" type="small" selected={selected}>
                {labels[item]}
              </ProgressLabel>
            </IconWrapper>
          )
        })}
      </IconContainer>
      <ProgressBefore />
      <ProgressAfter currentStep={currentStep} />
    </ProgressWrapper>
  )
}

export default ProgressBar
